
import Button from '../../components/Button/Button';
import Images from '../../state/stores/Image/images';
import React from 'react';
import { Body1Reg, Title2 } from '../../config/designSystem/typography';
import { Image,  View} from 'react-native';
import { SPACING } from '../../config/designSystem/Spacing';
import { isAndroid } from '../../config/designSystem/Layout';
import { openURL } from 'expo-linking';
import { useStores } from '../../hooks/useStores';


export default function NeedUpdate() {
  const rootStore = useStores();
  const labels = rootStore?.language.translate.MOBILE?.ROOT?.NEW_VERSION_AVAILABLE;

  const storeUrl = isAndroid? 'https://play.google.com/store/apps/details?id=com.evoluno.app':'https://apps.apple.com/be/app/evoluno/id1542778916';




  return (

    <View style={{padding: SPACING['sp-16'], flex:1, backgroundColor: 'white'}}>
      <View style={{flex:1, alignItems: 'center', rowGap: SPACING['sp-32']}}>
        <Image source={Images.illustrations.update_app} style={{width:104, height: 104}} />
        <Title2>{labels?.UPGRADE_YOUR_WELLBEING}</Title2>
        <Body1Reg align={true}> {labels?.EXPLANATION_NOT_COMPATIBLE_VERSION}</Body1Reg>
      </View>
      <View style={{bottom:0}}>
        <Button onPress={() => {openURL(storeUrl);}} label={labels?.GO_TO_STORE} />
      </View>
    </View>


  );
}

